<app-template-text [required]="required" [counter]="counter" [disabled]="disabled" [characters]="characters" [value]="value" [control]="control" [label]="label" />
